import React, { Component, useDebugValue } from "react";
import {withRouter} from 'react-router-dom';
import { connect } from 'react-redux';
import moment from "moment";
import { Form, FormGroup, FormFeedback, Col, Label, Input, Button, 
          Row, CustomInput, Popover, PopoverHeader, PopoverBody,
          Dropdown, DropdownItem, DropdownToggle, DropdownMenu,
          Modal, ModalBody, ModalHeader, Table
        } from "reactstrap";
import Tooltip from '../../../../components/UI/TooltipIcon/TooptipIcon';
import Toggle from "react-toggle";
import "react-toggle/style.css";
import Select from "react-select";
import Loading from '../../../../hoc/Loading/Loading';
import axios from '../../../../axios';
import * as actionCreators from '../../../../modules/actions/index';
import * as url from '../../../../utils/url';
// privacyLabel
import {privacyLabel, newDashboard} from '../../../../utils/constants';

// import Dropdown from '../../Reusable/Dropdown'
import DatePicker from 'react-datepicker';


class CreateDboard extends Component {
  createUserInputRef = React.createRef();
  createUserTableRef  = React.createRef();

  constructor(props) {
    super(props);
    this.state = {
      ...newDashboard
    };
    this.timer = null;

  }

  

  

  // componentDidMount() {
  //   window.scrollTo(0, 0);
  //   if( (this.props.chartDetails.createdBy && this.props.chartDetails.createdBy._id) && this.props.chartDetails.createdBy._id === this.props.user._id ) {
  //     if(this.state.isUserList || this.state.privacy==='CUSTOM'){
  //       this.getUserList()
  //     }
  //   }
  // }

 

  editTask=(field, isUndo)=>{
    // console.log('field---', field)
    let {updatedFields, task_copy, task, removedFields }=this.state
    updatedFields=updatedFields==null?[]:updatedFields
    if(updatedFields.indexOf(field)==-1){
      updatedFields.push(field)
      this.setState({updatedFields})
    } else {
       let res =updatedFields.filter(e=> e!=field)

      this.setState({ updatedFields:res })
    }
  }




  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  componentWillUnmount() { 
    document.removeEventListener("mousedown", this.handleClickOutside);
   }

   closeUserSearch=()=>{
    this.setState({displayUsers:[]})
  }

  handleClickOutside = (event) => { 
        if(this.createUserInputRef){
          if(this.createUserInputRef.current){
            let input =this.createUserInputRef.current
           
            if(this.createUserTableRef){
              if(this.createUserTableRef.current){
                let ut=this.createUserTableRef.current
                if( (input &&  !input.contains(event.target))  &&  ( ut && !ut.contains(event.target)) ){
                  this.closeUserSearch()
                }
              }
            }
          }
        }
    }


  changeDashboardTitle = (event) => {
    const { value } = event.target;
    this.setState({ title:value })
  }


  getUserList=()=>{
    let {displayUsers}=this.state
    if(displayUsers.length===0){
      axios.get(url.userListArray).then((response) => {
        this.setState({ displayUsers: response.data.data.map(e=> {
            if(e.firstName && e.lastName){
              return { "label": `${e.firstName}, ${e.lastName}`, "value": e._id, "permissions":0 }
            } else if (e.firstName || e.lastName){
              let name = e.firstName && e.firstName.length>0?e.firstName:e.lastName
              return { "label": `${name}`, "value": e._id, "permissions":0 }
            } else if (!e.firstName && !e.lastName) {
              return { "label": `${e.email}`, "value": e._id, "permissions":0 }
          }
          })
        });


    
      }).catch((error) => {
          console.log(error);
      })
    }
   
  }

  handleOptionChange = changeEvent => {
    // console.log(changeEvent.target)
    let permission = '';
    if (changeEvent === 'ENTERPRISE') {
      permission = 'VIEW';
      this.setState({
        privacy: changeEvent,
        permission,
        invitedUsers: [],
        isUserList:false
      });
    }  else if (changeEvent === 'CUSTOM'){
      this.setState({
        isUserList: true,
        privacy: changeEvent
      })
      // this.getUserList()
    }  else {
      this.setState({
        privacy: changeEvent,
        permission:'VIEW',
        invitedUsers:[],
        isUserList:false
      });
    }
  };

  

  handlePermissionChange = () => {
    let permission = (this.state.permission === 'EDIT') ? 'VIEW' : 'EDIT';
    this.setState({ permission: permission });
  }

  // Toggle popover
  togglePrivacySettings = () => {
    this.setState({
      privacyPopoverOpen: !this.state.privacyPopoverOpen,
      permissionPopoverOpen: false
    });
  }

  togglePersmission = () => {
    this.setState({
      permissionPopoverOpen: !this.state.permissionPopoverOpen,
      privacyPopoverOpen: false
    });
  }

  
  onUserSelect=(u)=>{
    let{invitedUsers}=this.state

    let result = invitedUsers.length==0 || invitedUsers.filter(item=> item.userId == u._id).length==0?invitedUsers.concat({
                    firstName: u.firstName,
                    lastName:u.lastName,
                    userId: u._id,
                    orgId: u.organizationId,
                    permissions:0
              }):invitedUsers

    this.setState({invitedUsers:result})
  }

  onUserSetPermissions=(p, u)=>{
    // console.log(p, u)
    let{invitedUsers}=this.state
    if(p && p!=null && p!=undefined){
        invitedUsers.forEach((item,index)=>{
          if(item.userId == u.userId ){
            invitedUsers[index].permissions = p.value
          }
      })
      this.setState({invitedUsers})
    } else {
        invitedUsers.forEach((item,index)=>{
          if(item.userId == u.userId ){
            invitedUsers[index].permissions = { label: "VIEW", value: 0 }
          }
        })
        this.setState({invitedUsers})
    }
    
  }

  toggleTaskView=()=> {
    this.setState( prevState=>({
      dropdownOpen: !prevState.dropdownOpen,
    }));
  }

  renderDropDownViews=()=>{
    let{privacy}=this.state
    return(
      <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggleTaskView} className="dbPrivacyDropdown createDashboard">
      <DropdownToggle caret>
        {privacyLabel[privacy]}
      </DropdownToggle>
      <DropdownMenu className="singleTaskViewMenu">
        {/* <DropdownItem header>Select a view</DropdownItem> */}
        <DropdownItem className="chartBtnView" onClick={()=>this.handleOptionChange('PRIVATE')}>{privacyLabel['PRIVATE']}</DropdownItem>
        <DropdownItem className="chartBtnView" onClick={()=>this.handleOptionChange('ENTERPRISE')}>{privacyLabel['ENTERPRISE']}</DropdownItem>
        <DropdownItem className="toolkitBtnView" onClick={()=>this.handleOptionChange('CUSTOM')}>{privacyLabel['CUSTOM']}</DropdownItem>  
      </DropdownMenu>
    </Dropdown>
    )
  }

  assignedUserDelay = ({ target })=>{
    let { value } = target;
    this.setState({customUser:value})
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      this.handleAssignUser(value);
    }, 1000);
  }
  


handleAssignUser = value => {
  // console.log('val---', value)
  let res
  if(value && value.length>0){
    axios.get(url.findUser(value)).then( (resp,idx) =>{
      let users = resp.data.data
      // console.log('users--', users)
      if(users.length==0){
        users = 'No users found'
      }


      this.setState({displayUsers:users})
    })
  } else {
    this.setState({displayUsers:[]})
  }
}



  privacyContent=(type)=>{
    let { privacy } = this.state;

    if(type==='enable'){
      return (
        <div className="dbViewPrivacyStatusContainer">
      <span className='dbViewPrivacyStatusTxt'>
        Privacy Status: 
        {this.renderDropDownViews()}
        </span></div>)
    } else {
      return  <span className="dashboard-privacy-label">{privacy}</span>
    }
  }

  removeUser=(user)=>{
    // console.log('u: ', user)
    let{invitedUsers}=this.state
    invitedUsers= invitedUsers.filter(e=>e.userId.toString()!=user.userId.toString())
    this.setState({invitedUsers})
  }

  renderPrivacyOptions=()=>{
    return this.privacyContent("enable")
    // if(chartDetails && chartDetails.createdBy  && chartDetails.createdBy._id){
    //     if(chartDetails.createdBy._id===user._id){
    //       return this.privacyContent("enable")
    //     } else if(isCopied) {
    //       return this.privacyContent("enable")
    //     } else {
    //       return this.privacyContent("disable")
    //     }
    // } else {
    //   return this.privacyContent("enable")
    // }
  }
 

  renderPermissions=()=>{
    let{privacy, invitedUsers, displayUsers, isUserList, customUser}=this.state
    if(privacy=='ENTERPRISE'){
      return(
        <span className="permissionsContainer">
         {/* <div className="float-right"> */}
           {/* <span id="permission-popover" style={{ marginRight: '10px' }} onClick={this.togglePersmission}><Tooltip /></span> */}
           <span className="dashboard-permission-label">Permissions:</span>
           {/* <Popover placement="left" isOpen={this.state.permissionPopoverOpen} target="permission-popover" toggle={this.togglePersmission}>
             <PopoverHeader className="popover-header-tooltip">Permissions</PopoverHeader>
             <PopoverBody className="popover-body-tooltip">Toggle from “View Only” to “View and Edit” to allow others you have shared this chart with, to make modifications to it. Note, you can always change the privacy settings and permissions again and/or at a later time.</PopoverBody>
           </Popover> */}
         {/* </div> */}
         <div className="dashboardPermissionOptions">
           <span className="dbPermissionValue">View Only</span>
           <span className="ml10">
             <Toggle
               defaultChecked={this.state.permission === 'EDIT'}
               icons={false}
               onChange={this.handlePermissionChange}
             />
           </span>
           <span className="dbPermissionValue ml10">View And Edit</span>
         </div>
       </span>
      )
    } else if(privacy=='CUSTOM' && isUserList){
      return(
        <span>
          {/* <Col sm={3} md={3} lg={3}>
            <div className="float-right">
              <span id="permission-popover" style={{ marginRight: '10px' }} onClick={this.togglePersmission}><Tooltip /></span>
                <span className="chart-permission-label float-right">
                  <span>Shared with</span>
                </span>
              <Popover placement="left" isOpen={this.state.permissionPopoverOpen} target="permission-popover" toggle={this.togglePersmission}>
                <PopoverHeader className="popover-header-tooltip"> Sharing </PopoverHeader>
                <PopoverBody className="popover-body-tooltip">
                  Selects users you would like to share this dashboard with.
                  </PopoverBody>
              </Popover>
            </div>
          </Col> */}

              {/* <Col sm={2} className="">
                <div className="chartLabel">Select Users</div>
              </Col> */}
              <span className="permissionsContainer"  ref={this.createUserInputRef} >
              <Input
             
                    name="assignedUser"
                    id=""
                    placeholder={"Select users to share this dashboard with"} 
                    className="inputBox-height"
                    onChange={this.assignedUserDelay}
                    value={customUser} 
                    autoComplete={'off'}
                  />
                    {displayUsers && displayUsers.length>0 && typeof(displayUsers)!=='string'?
                            <div className="divTableSingleTask"   ref={this.createUserTableRef} >
                            <div className="dbTableBody">
                                
                                  {displayUsers.map( user => {
                                    return (
                                        <div className="divTableRow" 
                                        onClick={()=>this.onUserSelect(user)} 
                                        key={user._id+user.organizationId}>
                                            <div className="dashboardTableCell">
                                              {user.firstName} {user.lastName}
                                            </div>
                                        </div>
                                    )
                                  })}
                            </div>
                            </div>
                      :
                      typeof(displayUsers)==='string'?
                      <span className='noUsersFound'>
                        {displayUsers}
                      </span>
                      :null
                      }
              
               </span>

              {/* <span className="dbViewPrivacyInputContainer" ref={this.createUserInputRef}>
              <Input
                    name="assignedUser"
                    id=""
                    placeholder={"Find users to share with"} 
                    className="inputBox-height"
                    onChange={this.assignedUserDelay}
                    value={customUser} 
                  />
                    {displayUsers && displayUsers.length>0 && typeof(displayUsers)!=='string'?
                            <div className="divTableSingleTask"  ref={this.createUserTableRef}>
                            <div className="dbTableBody">
                                
                                  {displayUsers.map( user => {
                                    return (
                                        <div className="divTableRow" 
                                        onClick={()=>this.onUserSelect(user)} 
                                        key={user._id+user.organizationId}>
                                            <div className="dashboardTableCell">
                                              {user.firstName} {user.lastName}
                                            </div>
                                        </div>
                                    )
                                  })}
                            </div>
                            </div>
                      :
                      typeof(displayUsers)==='string'?
                      <span className='noUsersFound'>
                        {displayUsers}
                      </span>
                      :null
                      }</span> */}
                {/* <Select
                    isMulti={true}
                    multi={true}
                    name="user-select" 
                    placeholder={"Select users to share this dashboard with"} 
                    value={invitedUsers.length>0?invitedUsers:''} 
                    isOpen={true}
                    options={displayUsers} 
                    onChange={itm =>this.onUserSelect(itm)}  
                    
                    className="basic-multi-select"
                    classNamePrefix="select"
                    /> */}
               
            {invitedUsers.length>0?
              <Table responsive hover className="dbPrivacyTable">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Access</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {invitedUsers.map(e=>{
                    let fullName= e.firstName + " " +e.lastName
                    return(
                      <tr className="dbPrivacyRow" key={e.userId} >
                        
                        <td >
                          {fullName}
                        </td>

                          <td>
                                <Select
                                  isClearable={false}

                                    name="permission-select" 
                                    placeholder={"Select a permission/privacy"} 
                                    value={e.permissions} 
                                    isOpen={true}
                                    options={[
                                      {label: 'View', value:0},
                                      {label: 'Edit', value:1},
                                    ]} 
                                    onChange={itm =>this.onUserSetPermissions(itm, e)}  
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                    />
                          </td>

                          <td className="dbRemoveUserCol">
                            <i onClick={()=>this.removeUser(e)} className="dashboardUserIcon flaticon-trash"></i>
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
                </Table>
            :
            null}
      
          </span>
      )
    }
  }

 

  privacySettingsModal=()=>{
    this.setState((prevState)=> ({
      isPrivacy: !prevState.isPrivacy  
    }))
  }

  closeActionsModal=()=>{
    this.setState({...newDashboard})
    this.props.closeActionsModal()
  }

  changePrivacySettings=()=>{
    this.setState((prevState)=> ({
      isPrivacy: false 
    }))
  }

  

  createDashboard=()=>{
    let{title, permission, privacy, invitedUsers}=this.state

    let isTitle = title.replace(/<\/?![^>]+(>|$)/g, "").replace(/[\. ,:-]+/g, "").replace(/^\n|\n$/g, '').length>0

    if(isTitle) {

      this.setState({errMsg:'', preventCreate:true})
      
      let payload={
        name:title, permission, privacy, invitedUsers
      }
      let that=this
      axios.post(url.createDashboard, payload).then((response) => {
        // /dashboard/:orgId/view/:id
        that.setState({preventCreate:false})
        let new_report = response.data.data

        let url =`/home/dashboard/${that.props.user.profile.organizationId._id}/view/${new_report._id}`
        // that.props.updateReport(new_report)
        // that.props.newDashboardUrl(url)
        that.props.history.push(url)
      }).catch((error) => { console.log(error) });
    } else {
      this.setState({errMsg:'Almost there! Please provide a meaningful name so we can create this great dashboard.'})
    }
  }

  closeAlertMsg=()=>{
    this.setState({errMsg:''})
  }

  // componentDidUpdate() {
  //   if (!this.props.isCreateModal) {
  //     this.setState({isCreateModal:true})
  //   }
  // }

  componentDidUpdate(prevProps, prevState) {
    let current_ch = prevProps.isCreateModal
    let prev_ch = this.props.isCreateModal
    if(current_ch!=prev_ch){
      // this.getAttachedItems()
      this.setState({isCreateModal: this.props.isCreateModal})
    }
  }

  render() {
    let { updatedFields, title,isCreateModal,preventCreate, errMsg} = this.state;
    updatedFields=updatedFields==null?[]:updatedFields
    return (
      <span className="dashboardSettingsContainer">
      

        <Modal isOpen={isCreateModal} className="dashboardViewModalContainer createModalContainer">
        <ModalHeader className="dashboardHeader" charCode="X"
          toggle={()=>this.closeActionsModal()}
          >
          <div className="dashboardModalTitle">Create a Dashboard </div>
        </ModalHeader>
              <ModalBody className="dashboardModalBody createDashboardModalContent">
              <span className='dashboardViewTitleContainer'>
          { updatedFields.indexOf('title')>-1?
            <Input type="text"
            onChange={this.changeDashboardTitle} 
            value={title}
            className="dashboardCreateTitleInputEdit" maxLength={64} /> 
          :
            <h5 className="dashboardCreateTitleInput editableTaskField" onClick={ ()=>this.editTask('title') } > 
              {title&&title.length>0?title:'New Dashboard Title'}
            </h5>
          }
          { updatedFields.indexOf('title')>-1?
            <span className='singleTaskEditBtn' onClick={()=>this.editTask('title')}>Close</span> 
            :<span className='singleTaskEditBtn' onClick={()=>this.editTask('title')}>Edit</span> 
          } 

        </span>
                
                  {this.renderPrivacyOptions()}
                  {this.renderPermissions()}


                  {errMsg.length>0?
                    <div className="alert alert-danger">
                      <span className="closeAlertMsg" onClick={()=> this.closeAlertMsg()}>X</span>
                      {errMsg}</div>:
                    null}


                  <div className="submitPrivacyContainer"
                  style={{ padding: '10px 0px 0px 0px' }}>
                      <Button className={`createDashboardModalBtn ${preventCreate?'disabledBtn':''}`} onClick={!preventCreate?()=>this.createDashboard():null} >
                        <span className="">
                         Create 
                        <span className="ml10 flaticon-tick"></span></span>
                      </Button>

                      <Button outline color='secondary' className="cancelDashboardModalBtn" onClick={()=>this.closeActionsModal()}>
                        <span className="">Cancel</span>
                      </Button>
                  </div>
                </ModalBody>
        </Modal>
      </span>
    );
  }
}


const mapStateToProps = state => {
  return {
    user: state.user,
    kpiMaster: state.kpiMaster,
    mappingMaster: state.mappingMaster,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onKpiMasterListFetched: (data) => dispatch(actionCreators.storeKpiMaster(data)),
    onMappingMasterListFetched: (data) => dispatch(actionCreators.storeMappingMaster(data)),
    onProfileUpdate: (data) => dispatch(actionCreators.updateProfileInfoSuccess(data)),
    updateNavBar: (header) => dispatch(actionCreators.navBarUpdate(header)),
    updateReport: (dashboard) => dispatch(actionCreators.updateReport(dashboard))

  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Loading(CreateDboard, axios)));

